import debounce from 'debounce';
import * as layout from '../../layout.js';
import Swiper from 'swiper';
import { Navigation, Autoplay, EffectFade } from 'swiper/modules';

const AUTOPLAY_DELAY_MS = 2500;

const promotionSection = layout.select('.promotion-slider');
const promotionContainer = layout.select('.promotion-slider__container');
const promotionSwiper = layout.select('.promotion-slider__swiper');

let promotionSwiperInstance = null;

function promotionSliderHeight() {

    const navbarHeight = layout.navbarHeight ?? 0;
    const promotionSectionHeight = window.innerHeight - navbarHeight;

    if ( promotionSection ) {
        promotionSection.style.paddingTop = `${navbarHeight}px`;
    }

    if ( promotionContainer ) {
        promotionContainer.style.height = `${promotionSectionHeight}px`;
    }

}

function promotionSwiperFunc() {

    if ( ! promotionSwiper ) {
        return;
    }

    promotionSwiperInstance = new Swiper(
        promotionSwiper,
        {
            modules: [Navigation, Autoplay, EffectFade],
            direction: 'horizontal',
            effect: 'fade',
            loop: true,
            autoplay: {
                delay: AUTOPLAY_DELAY_MS,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            parallax: true,
        }
    )

}

document.addEventListener('DOMContentLoaded', () => {
    promotionSliderHeight();
})

window.addEventListener('load', () => {
    promotionSwiperFunc();
})

window.addEventListener('resize', debounce(() => {
    promotionSliderHeight();
}))
